<template>
    <ul class="breadcrumb-list-wrapper">
        <li
            v-for="(track, index) in trace"
            :key="index"
            class="breadcrumb-item h6 mb-0 heading"
        >
            <span v-if="index === trace.length - 1">
                {{ track.text }}
            </span>
            <router-link v-else-if="track.to" :to="track.to">
                {{ track.text }}
            </router-link>
            <a v-else-if="track.link && track.href">
                {{ track.text }}
            </a>
            <span v-else>
                {{ track.text }}
            </span>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Breadcrumb',
    props: {
        trace: Array,
    },
};
</script>

<style scoped>
.breadcrumb-list-wrapper {
    padding: 0;
    margin-block-end: 0px;
    line-height: 13px;
    font-size: 0.7rem;
}
.breadcrumb-item {
    display: inline-block;
}

.breadcrumb-item > span {
    letter-spacing: 1px;
    color: rgba(50, 60, 83, 1);
}

.breadcrumb-item > a {
    letter-spacing: 1px;
}
</style>
